import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import AOS from 'aos';
import 'aos/dist/aos.css';
import LoadingScreen from './components/LoadingScreen';
import Navbar from './components/Navbar';
import Home from './components/Home';
import Contact from './components/Contact';
import Careers from './components/Careers';
import PrivacyPolicy from './components/Privacypolicy';
import TermsConditions from './components/Termsconditions';
import ScrollToTop from './components/ScrollToTop';
import './App.css';

const theme = createTheme({
  palette: {
    primary: {
      main: '#51A8B1',
    },
    secondary: {
      main: '#A8CF45',
    },
    background: {
      default: '#ffffff',
      paper: '#f8f9fa',
    },
  },
  typography: {
    fontFamily: 'Quicksand, sans-serif',
    h1: {
      fontFamily: 'Quicksand, sans-serif',
      fontWeight: 700,
    },
    h2: {
      fontFamily: 'Quicksand, sans-serif',
      fontWeight: 600,
    },
    h3: {
      fontFamily: 'Quicksand, sans-serif',
      fontWeight: 600,
    },
    h4: {
      fontFamily: 'Quicksand, sans-serif',
      fontWeight: 500,
    },
    h5: {
      fontFamily: 'Quicksand, sans-serif',
      fontWeight: 500,
    },
    h6: {
      fontFamily: 'Quicksand, sans-serif',
      fontWeight: 500,
    },
    button: {
      fontFamily: 'Barlow, sans-serif',
      fontWeight: 600,
    },
  },
});

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      easing: 'ease-out-cubic',
    });
    
    // Simulate loading time
    setTimeout(() => {
      setLoading(false);
    }, 2500);
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        {loading ? (
          <LoadingScreen />
        ) : (
          <>
            <ScrollToTop />
            <Navbar />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/careers" element={<Careers />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-conditions" element={<TermsConditions />} />
            </Routes>
          </>
        )}
      </Router>
    </ThemeProvider>
  );
}

export default App;